import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface EmptyStateProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export default function EmptyState({
  title = '暂无数据',
  description = '',
  icon,
  action
}: EmptyStateProps) {
  return (
    <motion.div
      className="ios-empty"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="ios-empty-icon">
        {icon || (
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="9" y1="9" x2="15" y2="15" />
            <line x1="15" y1="9" x2="9" y2="15" />
          </svg>
        )}
      </div>
      <div style={{ fontSize: 17, fontWeight: 600, color: 'var(--color-foreground)', marginBottom: 4 }}>{title}</div>
      {description && (
        <div style={{ fontSize: 14, color: 'var(--color-foreground-tertiary)', marginBottom: 16 }}>{description}</div>
      )}
      {action}
    </motion.div>
  );
}
